import { SURCHARGES_CATEGORY } from '../../checklistCategories';
import { formatContextDate, formatMoney } from '../../shared/checklistUtils';
import type { ApprovalQueueItem } from '../../types';

import type { SurchargeTableRow, SurchargesChecklistRow } from './types';

export function buildSurchargesQueueItem(row: SurchargesChecklistRow): ApprovalQueueItem {
  return {
    categoryId: SURCHARGES_CATEGORY.id,
    categoryLabel: SURCHARGES_CATEGORY.label,
    description: `${row.name} surcharge rule requires review.`,
    details: row.details,
    id: row.id,
    title: row.name,
  };
}

export function buildSurchargeTableQueueItem(row: SurchargeTableRow): ApprovalQueueItem {
  return {
    categoryId: SURCHARGES_CATEGORY.id,
    categoryLabel: SURCHARGES_CATEGORY.label,
    description: `${row.name} surcharge requires review.`,
    details: [
      { label: 'Period', value: `${formatContextDate(row.fromDate)} – ${formatContextDate(row.toDate)}` },
      { label: 'Converted Cost', value: formatMoney(row.convertedCost, row.currencyCode) },
      { label: 'Surcharge Price', value: formatMoney(row.surchargePrice, row.currencyCode) },
      { label: 'Accumulate', value: row.accumulate ? 'Yes' : 'No' },
      {
        label: 'Inside Travel Period',
        value: row.insideTravelPeriod === null ? 'N/A' : row.insideTravelPeriod ? 'Yes' : 'No',
      },
      {
        label: 'Blackout Overlap',
        value: row.blackoutOverlap === null ? 'N/A' : row.blackoutOverlap ? 'Yes' : 'No',
      },
    ],
    id: row.id,
    title: row.name,
  };
}

export function getSurchargesSearchText(row: SurchargesChecklistRow) {
  return [row.name, row.field, row.statusLabel].join(' ');
}

export function getSurchargeTableSearchText(row: SurchargeTableRow) {
  return [row.name, row.statusLabel].join(' ');
}
